import type { Middleware } from '@reduxjs/toolkit';
import { logger } from '../../lib/logger';

const SLOW_ACTION_THRESHOLD = 16; // One frame at 60fps

export const performanceMiddleware: Middleware = () => (next) => (action) => {
  if (process.env.NODE_ENV === 'development') {
    const start = performance.now();
    const result = next(action);
    const end = performance.now();
    const duration = end - start;

    if (duration > SLOW_ACTION_THRESHOLD) {
      logger.warn(
        `⚠️ Slow Redux action detected: ${action.type}`,
        `\nDuration: ${duration.toFixed(2)}ms`,
        `\nPayload size: ${JSON.stringify(action.payload || {}).length} chars`
      );
    }

    return result;
  }

  return next(action);
};
